var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createSlice, createAsyncThunk, } from "@reduxjs/toolkit";
import api from "api/system-performance";
export var initialState = {
    isLoading: false,
    isPerformanceDataPending: false,
    isPerformanceDataWithEsPending: false,
    isPerformanceDataValid: false,
    hasSettledUserCalculation: false,
    showEnergySavePerformance: false,
    cupsOutsideOfObject: [],
    playLocationPercent: 0,
};
var addCupOutsideOfObject = function (state, _a) {
    var cupId = _a.payload;
    if (state.cupsOutsideOfObject.includes(cupId))
        return;
    state.cupsOutsideOfObject = __spreadArray(__spreadArray([], __read(state.cupsOutsideOfObject), false), [cupId], false);
};
var removeCupOutsideOfObject = function (state, _a) {
    var cupId = _a.payload;
    if (!state.cupsOutsideOfObject.includes(cupId))
        return;
    state.cupsOutsideOfObject = state.cupsOutsideOfObject.filter(function (id) { return id !== cupId; });
};
var setShowEnergySavePerformance = function (state, action) {
    state.showEnergySavePerformance = action.payload;
};
var setPlayLocationPercent = function (state, action) {
    state.playLocationPercent = action.payload;
};
var increasePlayLocationPercentBy = function (state, action) {
    state.playLocationPercent = state.playLocationPercent + action.payload;
};
var setIsPerformanceDataValid = function (state, action) {
    state.isPerformanceDataValid = action.payload;
};
var showPerformanceData = function (state) {
    //If a new sanity check or system performance is being fetched when called, instead set data to pending.
    if (state.isPerformanceDataPending || state.isPerformanceDataWithEsPending) {
        state.isLoading = true;
    }
    else if (state.sanityCheckData &&
        (!state.sanityCheckData.validationPassed ||
            !state.sanityCheckData.partSecuredReachable)) {
        // The calculation finished but either its sanity check failed or part
        // secured was never reached — don't reveal the (bad) data, and leave
        // isPerformanceDataValid false so the button stays on "Run simulation".
        // The button surfaces the matching failure notification instead.
        state.isLoading = false;
        state.hasSettledUserCalculation = true;
    }
    else if (state.preloadedData) {
        state.data = state.preloadedData;
        state.isPerformanceDataValid = true;
        state.isLoading = false;
        state.hasSettledUserCalculation = true;
    }
    else if (state.error) {
        state.error = __assign(__assign({}, state.error), { visible: true });
        state.isLoading = false;
        state.hasSettledUserCalculation = true;
    }
    else {
        // The user asked for results before any calculation has produced them —
        // e.g. right after a page refresh (the performance slice isn't persisted),
        // before the automatic recalculation has started. Show progress; the
        // calculation observer reveals the data once it arrives.
        state.isLoading = true;
    }
};
var markCalculationPending = function (state) {
    // A system edit has queued a fresh calculation (it fires after a debounce).
    // Treat the current data as pending right away so that, if the user starts a
    // simulation during the debounce window, the button shows progress instead of
    // briefly revealing the now-stale results.
    state.isPerformanceDataPending = true;
    state.isPerformanceDataWithEsPending = true;
    state.isPerformanceDataValid = false;
    // The system changed, so any previously settled result no longer applies.
    state.hasSettledUserCalculation = false;
};
var clearPerformanceData = function (state) {
    state.data = undefined;
    state.preloadedData = undefined;
    state.isPerformanceDataPending = false;
    state.isPerformanceDataWithEsPending = false;
    state.systemDataSnapshot = undefined;
    state.isLoading = false;
    state.error = undefined;
    state.isPerformanceDataValid = false;
    state.hasSettledUserCalculation = false;
    state.showEnergySavePerformance = false;
    state.sanityCheckData = undefined;
};
var getDataWithoutEs = createAsyncThunk("system-performance/getDataWithoutEs", function (_, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var systemDataDefineParameters, response, err_1, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                systemDataDefineParameters = thunkApi.getState().systemDataDefineParameters.dataState.data;
                return [4 /*yield*/, api.getDataWithoutEs(thunkApi.getState(), thunkApi.extra.computationApiBaseUrl)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, {
                        systemPerformance: {
                            energySavingOff: response.energySavingOff,
                        },
                        systemData: systemDataDefineParameters,
                        sanityCheck: response.sanityCheck,
                    }];
            case 2:
                err_1 = _a.sent();
                error = err_1;
                return [2 /*return*/, thunkApi.rejectWithValue({
                        message: error.message,
                        type: error.type,
                        extra: error.extra,
                        visible: false,
                    })];
            case 3: return [2 /*return*/];
        }
    });
}); });
var getDataWithEs = createAsyncThunk("system-performance/getDataWithEs", function (_, thunkApi) { return __awaiter(void 0, void 0, void 0, function () {
    var response, err_2, error;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.getDataWithEs(thunkApi.getState(), thunkApi.extra.computationApiBaseUrl)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, {
                        systemPerformance: {
                            energySavingOn: response === null || response === void 0 ? void 0 : response.energySavingOn,
                        },
                        sanityCheck: response === null || response === void 0 ? void 0 : response.sanityCheck,
                    }];
            case 2:
                err_2 = _a.sent();
                error = err_2;
                return [2 /*return*/, thunkApi.rejectWithValue({
                        message: error.message,
                        type: error.type,
                        extra: error.extra,
                        visible: false,
                    })];
            case 3: return [2 /*return*/];
        }
    });
}); });
var systemPerformanceSlice = createSlice({
    name: "system-performance",
    initialState: initialState,
    reducers: {
        setShowEnergySavePerformance: setShowEnergySavePerformance,
        setPlayLocationPercent: setPlayLocationPercent,
        increasePlayLocationPercentBy: increasePlayLocationPercentBy,
        setIsPerformanceDataValid: setIsPerformanceDataValid,
        markCalculationPending: markCalculationPending,
        clearPerformanceData: clearPerformanceData,
        showPerformanceData: showPerformanceData,
        addCupOutsideOfObject: addCupOutsideOfObject,
        removeCupOutsideOfObject: removeCupOutsideOfObject,
    },
    extraReducers: function (builder) {
        builder.addCase(getDataWithoutEs.fulfilled, function (state, _a) {
            var payload = _a.payload;
            state.preloadedData = payload.systemPerformance;
            state.systemDataSnapshot = payload.systemData;
            state.isPerformanceDataPending = false;
            state.error = undefined;
            state.sanityCheckData = payload.sanityCheck;
        });
        builder.addCase(getDataWithoutEs.rejected, function (state, _a) {
            var payload = _a.payload, meta = _a.meta;
            state.error = payload;
            state.isPerformanceDataPending = false;
            if (!meta.aborted) {
                state.preloadedData = undefined;
                /* The ES request only fires after the initial request succeeds, so a
                 * real failure here means it never will. Clear its pending flag too —
                 * otherwise the button stays stuck in a loading state and never gets
                 * to surface the error. (On abort a new calculation is already queued,
                 * so we leave the flag set to keep showing progress.) */
                state.isPerformanceDataWithEsPending = false;
            }
        });
        builder.addCase(getDataWithoutEs.pending, function (state) {
            state.isPerformanceDataPending = true;
            /* Since we will always fire a request with ES after the initial without ES request is fulfilled,
             * we set WithEs to pending as well to ensure the "Calculate Performance" button don't falsely show it's state
             * as completed before the ES request is fulfilled as well. */
            state.isPerformanceDataWithEsPending = true;
            state.isPerformanceDataValid = false;
        });
        builder.addCase(getDataWithEs.fulfilled, function (state, _a) {
            var payload = _a.payload;
            if (state.preloadedData) {
                state.preloadedData.energySavingOn =
                    payload.systemPerformance.energySavingOn;
            }
            if (payload.sanityCheck) {
                state.sanityCheckData = payload.sanityCheck;
            }
            state.isPerformanceDataWithEsPending = false;
            state.error = undefined;
            var canShowEnergySavePerformance = (payload.systemPerformance.energySavingOn &&
                payload.systemPerformance.energySavingOn.systemTimeToEnergySave >
                    0) ||
                false;
            state.showEnergySavePerformance =
                canShowEnergySavePerformance && state.showEnergySavePerformance;
        });
        builder.addCase(getDataWithEs.rejected, function (state, _a) {
            var payload = _a.payload, meta = _a.meta;
            state.error = payload;
            state.isPerformanceDataWithEsPending = false;
            if (!meta.aborted) {
                state.preloadedData = undefined;
            }
        });
        builder.addCase(getDataWithEs.pending, function (state) {
            state.isPerformanceDataWithEsPending = true;
            state.isPerformanceDataValid = false;
        });
    },
});
var allActions = systemPerformanceSlice.actions, reducer = systemPerformanceSlice.reducer;
export var callableActions = {
    getSystemPerformance: getDataWithoutEs,
    getSystemPerformanceWithEs: getDataWithEs,
    setShowEnergySavePerformance: allActions.setShowEnergySavePerformance,
    setPlayLocationPercent: allActions.setPlayLocationPercent,
    increasePlayLocationPercentBy: allActions.increasePlayLocationPercentBy,
    setIsPerformanceDataValid: allActions.setIsPerformanceDataValid,
    markCalculationPending: allActions.markCalculationPending,
    clearPerformanceData: allActions.clearPerformanceData,
    showPerformanceData: allActions.showPerformanceData,
    addCupOutsideOfObject: allActions.addCupOutsideOfObject,
    removeCupOutsideOfObject: allActions.removeCupOutsideOfObject,
};
export var internalActions = {};
export default reducer;
